import type { Violation } from '../../utils/mapViolations';

/**
 * Setzt einen Listenpfad vor die Feldpfade einer Antwort.
 *
 * Die Ofenzeilen werden je Zeile ueber einen eigenen `plantKilnsApi`-Aufruf gespeichert. Eine
 * 422-Antwort daraus kennt nur ihre eigenen Felder (`name`, `activeUntil`), nicht die Stelle der
 * Zeile im Werksformular -- ohne Umschreiben landet der Fehler am Namensfeld des Werks statt an
 * der betroffenen Ofenzeile.
 *
 * `mapViolations` uebersetzt Symfonys `[i]`-Schreibweise anschliessend in Mantines Punktpfade;
 * hier wird deshalb bereits die Punktform erzeugt, wie sie `form.setErrors` erwartet.
 */
export function prefixViolationPaths(violations: Violation[], prefix: string): Violation[] {
  return violations.map((violation) => ({
    ...violation,
    propertyPath: violation.propertyPath ? `${prefix}.${violation.propertyPath}` : prefix,
  }));
}
